import React, { useEffect } from 'react';
import Menu from '../Menubar/Menu';

import "./Datenerfassungstyle.css";
import { Routes, Route, useNavigate } from 'react-router-dom';
import Liniendaten from './Liniendaten/Liniendaten';
import NeuesErfassungsjahr from './Anlegen/NeuesErfassungsjahr';
import Bahnhofsdaten from './Bahnhofsdaten/Bahnhofsdaten';
import Abschnittsdaten from './Abschnittsdaten/Abschnittsdaten';
import Verkehrsvertragsdaten from './Verkehrsvertragsdaten/Verkehrsvertragsdaten';
import { Categories } from '../MainMenu/MenüSicht';
var MonitorApi = require('monitor-api');


export default function Datenerfassung({myApiClient, setSection}) {
  const navigate = useNavigate();

  var vvdInstance = new MonitorApi.VerkehrsvertragsdatenApi(myApiClient)
  var vvInstance = new MonitorApi.VerkehrsvertragApi(myApiClient);
  var statusInstance = new MonitorApi.StatusApi(myApiClient);
  var zvInstance = new MonitorApi.ZweckverbandApi(myApiClient);
  var ldInstance = new MonitorApi.LiniendatenApi(myApiClient);
  var bhfdInstance = new MonitorApi.BahnhofsdatenApi(myApiClient);
  var absdInstance = new MonitorApi.AbschnittsdatenApi(myApiClient);

  const auth = sessionStorage.getItem('token');


  useEffect(() => {
    setSection('Datenerfassung');
  }, [setSection]);

  const clickDe = e => {
    e.preventDefault();
    navigate(`../datenerfassung/${e.target.value}`, {replace: true});
  }

  return (
    <div className="next-to-menu">
    <Menu/>
      <Categories>
        <div className="SDMenu"> 

          <button value="verkehrsvertragsdaten" onClick={clickDe}>Verkehrsvertragsdaten</button>
          <button value="abschnittsdaten" onClick={clickDe}>Abschnittsdaten</button>
          <button value="bahnhofsdaten" onClick={clickDe}>Bahnhofsdaten</button>
          <button value="liniendaten" onClick={clickDe}>Liniendaten</button>

          {auth.includes('level1') &&
            <button value="neues-jahr" onClick={clickDe}>neues Jahr</button>
          } 
        </div>
        
        <Routes>
          <Route path={`/verkehrsvertragsdaten`} element={<Verkehrsvertragsdaten vvdInstance={vvdInstance} vvInstance={vvInstance} statusInstance={statusInstance} zvInstance={zvInstance}/>} />
          <Route path={`/liniendaten`} element={<Liniendaten vvInstance={vvInstance} statusInstance={statusInstance} zvInstance={zvInstance} ldInstance={ldInstance}/>} />
          <Route path={`/bahnhofsdaten`} element={<Bahnhofsdaten vvInstance={vvInstance} statusInstance={statusInstance} zvInstance={zvInstance} bhfdInstance={bhfdInstance}/>} />
          <Route path={`/abschnittsdaten`} element={<Abschnittsdaten vvInstance={vvInstance} statusInstance={statusInstance} zvInstance={zvInstance} absdInstance={absdInstance}/>} />
          <Route path={`/neues-jahr`} element={<NeuesErfassungsjahr vvdInstance={vvdInstance} ldInstance={ldInstance} bhfdInstance={bhfdInstance} absdInstance={absdInstance}/>} />
        </Routes>
      </Categories>
    </div>
  )
}